import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const StatusFilter = props => {
  const statusOptions = [
    { value: "ALL", label: "All" },
    { value: "CREATED", label: "Created" },
    { value: "OPENED", label: "In Progress" },
    { value: "LOAD_VERIFIED", label: "Load Verified" },
    { value: "COMPLETED", label: "Completed" },
    { value: "CANCELLED", label: "Cancelled" }
  ];
  const value = props.value;
  const handleChange = selectedOption => {
    props.onChange(selectedOption.value);
  };

  const spanStyle = {
    verticalAlign: "top",
    marginTop: 8,
    marginRight: 5,
    display: "inline-block"
  };

  return (
    <div>
      <span style={spanStyle}>Status</span>
      <Select
        className="filter-select status-filter-select"
        clearable={false}
        value={value}
        onChange={handleChange}
        options={statusOptions}
      />
    </div>
  );
};
StatusFilter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};
StatusFilter.defaultProps = { value: "ALL" };

export default StatusFilter;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/StatusFilter.js